import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import SellIn from "@/pages/SellIn";
import SellOut from "@/pages/SellOut";
import Targets from "@/pages/Targets";
import Schemes from "@/pages/Schemes";
import Visits from "@/pages/Visits";
import Alerts from "@/pages/Alerts";
import Copilot from "@/pages/Copilot";
import Products from "@/pages/Products";
import Stores from "@/pages/Stores";
import Distributors from "@/pages/Distributors";
import ReportsUpload from "@/pages/reports/ReportsUpload";
import TertiaryReport from "@/pages/reports/TertiaryReport";
import DsrReport from "@/pages/reports/DsrReport";
import OffersReport from "@/pages/reports/OffersReport";
import EossReport from "@/pages/reports/EossReport";
import GujratDsrForm from "@/pages/reports/GujratDsrForm";
import AdminUsers from "@/pages/AdminUsers";
import AdminMasters from "@/pages/AdminMasters";
import AdminHierarchy from "@/pages/AdminHierarchy";
import AdminStoreMaster from "@/pages/AdminStoreMaster";
import AdminEossConfig from "@/pages/AdminEossConfig";
import DailySales from "@/pages/spykar/DailySales";
import Reconciliation from "@/pages/spykar/Reconciliation";
import DiscountCompliance from "@/pages/spykar/DiscountCompliance";
import PosFormats from "@/pages/spykar/PosFormats";

function Protected({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="grid min-h-screen place-items-center text-[12px] text-muted-foreground" data-testid="auth-loading">
                Checking session…
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    return children;
}

function BrandDocTitle() {
    useEffect(() => {
        document.title = "Fundle · MBO Operating System";
    }, []);
    return null;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <BrandDocTitle />
                    <Toaster position="top-right" richColors closeButton />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/"
                            element={
                                <Protected>
                                    <AppLayout />
                                </Protected>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="inventory" element={<Inventory />} />
                            <Route path="sellin" element={<SellIn />} />
                            <Route path="sellout" element={<SellOut />} />
                            <Route path="targets" element={<Targets />} />
                            <Route path="schemes" element={<Schemes />} />
                            <Route path="visits" element={<Visits />} />
                            <Route path="alerts" element={<Alerts />} />
                            <Route path="copilot" element={<Copilot />} />
                            <Route path="masters/products" element={<Products />} />
                            <Route path="masters/stores" element={<Stores />} />
                            <Route path="masters/distributors" element={<Distributors />} />
                            <Route path="reports/upload" element={<ReportsUpload />} />
                            <Route path="reports/tertiary" element={<TertiaryReport />} />
                            <Route path="reports/dsr" element={<DsrReport />} />
                            <Route path="reports/offers" element={<OffersReport />} />
                            <Route path="reports/eoss" element={<EossReport />} />
                            <Route path="reports/gujrat-dsr" element={<GujratDsrForm />} />
                            <Route path="admin/users" element={<AdminUsers />} />
                            <Route path="admin/hierarchy" element={<AdminHierarchy />} />
                            <Route path="admin/masters" element={<AdminMasters />} />
                            <Route path="admin/store-master" element={<AdminStoreMaster />} />
                            <Route path="admin/eoss-config" element={<AdminEossConfig />} />
                            <Route path="spykar/daily-sales" element={<DailySales />} />
                            <Route path="spykar/reconciliation" element={<Reconciliation />} />
                            <Route path="spykar/discount-compliance" element={<DiscountCompliance />} />
                            <Route path="spykar/pos-formats" element={<PosFormats />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
